import http from "../http-common";

export default class FAQService {
  getFAQs(urlPath: string) {
    let url = `/faq?path=${encodeURIComponent(urlPath)}`;

    return http.get(url);
  }
}